import { useState, useEffect } from "react";
import { Box, Typography, Tooltip, IconButton, TextField } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../../main/detail/Detail";
import { rsActiveMenu, rsProgress, rsParentCom } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseHomeLanding } from "./UseHomeLanding";
import { DataGrid, faIR } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomPagination from "../../../components/CustomPagination";
import EditIcon from "@mui/icons-material/Edit";
import DeleteRow from "../../../components/DeleteRow";

export default function Landings(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { GetHomeLandings, deleteLandingBox } = UseHomeLanding();
  const [model, setModel] = useState();
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [searchSubGroup, setSearchSubGroup] = useState(
    location.state && location.state.searchSubGroup
      ? location.state.searchSubGroup
      : ""
  );
  const [filt, setFilt] = useState([]);
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  useEffect(() => {
    setFilt([
      {
        columnField: "title",
        operatorValue: "contains",
        value: searchSubGroup,
      },
    ]);
  }, [searchSubGroup]);

  useEffect(() => {
    if (location.state && location.state.LandingID) {
      setProgress(true);
      GetHomeLandings(location.state.LandingID, (callback) => {
        setModel(callback);
      });
    }
  }, [location.state]);

  const newFunc = () => {
    return navigate("/LandingsManage/addLanding", {
      state: {
        backName: "افزودن لندینگ",
        searchSubGroup: searchSubGroup,
        model: model,
        LandingID: location.state.LandingID,
        componentFaTitle: location.state.componentFaTitle,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
    },
    {
      field: "title",
      headerName: "عنوان",
      width: 330,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "panelNO",
      headerName: "پنل",
      width: 100,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "عملیات",
      sortable: false,
      width: 120,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="ویرایش">
              <IconButton
                onClick={() => {
                  return navigate("/LandingsManage/editLanding", {
                    state: {
                      backName: "ویرایش لندینگ",
                      model: cellValues.row,
                      LandingID: location.state.LandingID,
                      LanID: cellValues.row.id,
                      componentFaTitle: location.state.componentFaTitle,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.title,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <TextField
            placeholder="جستجو"
            size="small"
            variant="outlined"
            value={searchSubGroup}
            inputProps={{ "aria-label": "search" }}
            onChange={(evt) => {
              setSearchSubGroup(evt.target.value);
            }}
          />
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: msParentCom.backUrl,
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: msParentCom.parentComs },
          {
            name: "مدیریت" + " " + location.state.componentFaTitle,
            url: "/LandingsManage",
          },
        ],
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          gap: 5,
        }}
      >
        <DataGrid
          className="ltr-grid"
          filterModel={{
            items: filt,
          }}
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          rows={model ? model : []}
          page={pageState.page - 1}
          pageSize={20}
          Pagination
          onPageChange={(newPage) => {
            setPageState((old) => ({ ...pageState, page: newPage + 1 }));
          }}
          rowCount={model && model.length ? model.length : 1}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              newFunc: newFunc,
              isLtr: true,
              rowCount: model && model.length ? model.length : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: "rowIndex",
                  sort: "asc",
                },
              ],
            },
          }}
        />
        <DeleteRow
          deleteState={deleteState}
          setDeleteState={setDeleteState}
          type={"لندینگ"}
          callback={() => {
            setProgress(true);
            deleteLandingBox(deleteState.id, () => {
              GetHomeLandings(location.state.LandingID, (callback) => {
                setModel(callback);
              });
            });
          }}
        ></DeleteRow>
      </Box>
    </Detail>
  );
}
